import React, { useState, useEffect } from 'react';
import Profile from '../Profile/Profile';
import AuthForm from '../AuthForm/AuthForm';
import './MainPageProfile.css';
import ActionPanel from '../ActionPanel/ActionPanel';
import ListCircleMenu from '../ListCircleMenu/ListCircleMenu';
import { createPortal } from 'react-dom';

import { getPayload } from '../../utils/getPayload';
import { fetchMyOrganisation } from '../../api/orgsApi';
import { formatCompanyName } from '../../utils/formatCompanyName';
import LoginButton from '../LoginButton/LoginButton';
import { useAuth } from '../../Context/AuthContext';
import { useWebSocket } from '../../hooks/useWebSocket';
import NotificationPopup from '../NotificationPopup/NotificationPopup';
import { getTokensFromCookies } from '../../api/AuthApi';
import IphoneStyleIconMenu from '../IphoneStyleIconMenu/IphoneStyleIconMenu';

import { getUserData } from '../../api/userDataApi';
import Cookies from 'js-cookie';

const MainPageProfile = () => {
  const [activeBlok, setActiveBlock] = useState(null);
  const [isActiveCircleMenu, setIsActiveCircleMenu] = useState('');
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [profileData, setProfileData] = useState({});
  const [myOrganisationList, setMyOrganisationList] = useState([]);

  const { isAuthenticated, logout } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSelectedBlock = (activeBlok) => {
    setActiveBlock(activeBlok);
  };

  const toggleMenu = (menuId) => {
    setIsActiveCircleMenu(menuId);
  };

  useEffect(() => {
    const { a_token } = getTokensFromCookies();
    if (!a_token) return;
    setProfileData(getPayload(a_token));
  }, [activeBlok]);

  const fetchOrganisation = async () => {
    if (!isAuthenticated) return;

    try {
      const res = await fetchMyOrganisation(profileData.uuid);

      const updateMyOrganisationList = res.data.map((org) => {
        const formattedName = formatCompanyName(org.name);
        const match = formattedName.match(/"([^"]+)"/);

        return {
          ...org,
          label: match ? match[1] : formattedName,
          authStatus: true,
        };
      });

      setMyOrganisationList(updateMyOrganisationList);
    } catch (error) {
      console.error('Ошибка при получении организаций:', error);
    }
  };

  useEffect(() => {
    if (isAuthenticated && profileData.uuid) {
      fetchOrganisation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, profileData.uuid]);

  const handleClearData = () => {
    setMyOrganisationList([]);
    setProfileData({});
  };

  const { messages } = useWebSocket('');

  useEffect(() => {
    if (messages?.event === 'notice_worker_add') {
      setNotificationMessage(messages.payload.message);
      setIsNotificationVisible(true);
    }

    if (messages?.event === 'notice_worker_add_confirm_organisation') {
      setNotificationMessage(` ${messages.payload.fio} принял приглашение`);
      setIsNotificationVisible(true);
    }
  }, [messages]);

  const handleRedirectMessenger = () => {
    try {
      window.location.href = window.APP_CONFIG.MESSENGER_DOMAIN;
    } catch (e) {
      console.error('Ошибка при переходе в мессенджер:', e);
    }
  };

  const handleRedirectCRM = async () => {
    try {
      const res = await getUserData();
      const userData = res.data;

      if (userData.type_id && userData.type_id !== 2) {
        Cookies.set('current_organisation', userData.current_organisation, {
          expires: 7,
          domain: `.${window.APP_CONFIG?.TOKEN_DOMAIN}`,
          secure: true,
          sameSite: 'None',
        });

        const redirectUrl = new URL('https://crm.multi-mir.ru');
        redirectUrl.searchParams.set('module', 'kanban');

        window.location.href = redirectUrl.toString();
        return;
      }

      console.error('Ошибка перехода в ЛК');
    } catch (e) {
      console.error('Ошибка при переходе в ЛК:', e);
    }
  };

  const handleOpenLogoutPopup = () => {
    handleSelectedBlock('exit');
    logout();
  };

  return (
    <>
      {!isAuthenticated && (
        <LoginButton handleSelectedBlock={handleSelectedBlock} activeBlok={activeBlok} />
      )}
      <div className="main-page-profile">
        {isAuthenticated && isMobile && (
          <IphoneStyleIconMenu
            onProfileClick={handleRedirectCRM}
            onMessengerClick={handleRedirectMessenger}
            onLogoutClick={handleOpenLogoutPopup}
          />
        )}

        {isAuthenticated && !isMobile && (
          <ActionPanel
            isAuthenticated={isAuthenticated}
            handleSelectedBlock={handleSelectedBlock}
            activeBlok={activeBlok}
          />
        )}

        {isAuthenticated && !isMobile && (
          <Profile
            fetchOrganisation={fetchOrganisation}
            handleSelectedBlock={handleSelectedBlock}
            activeBlok={activeBlok}
            user_id={profileData.uuid}
          />
        )}

        {isAuthenticated && !isMobile && (
          <ListCircleMenu
            user_id={profileData.uuid}
            isAuthenticated={isAuthenticated}
            handleSelectedBlock={handleSelectedBlock}
            isActiveCircleMenu={isActiveCircleMenu}
            myOrganisationList={myOrganisationList}
            toggleMenu={toggleMenu}
          />
        )}

        <AuthForm
          toggleMenu={toggleMenu}
          activeBlok={activeBlok}
          handleSelectedBlock={handleSelectedBlock}
          fetchOrganisation={fetchOrganisation}
          handleClearData={handleClearData}
          isMobile={isMobile}
        />
      </div>

      {isNotificationVisible &&
        createPortal(
          <NotificationPopup
            duration={5000}
            message={notificationMessage}
            onClose={() => setNotificationMessage('')}
          />,
          document.body,
        )}
    </>
  );
};

export default MainPageProfile;
